// @flow
import React, { Component } from 'react';
import Routes from './routes/Routes';

import { ConfigProvider } from 'react-avatar';

// Themes
import './assets/scss/Saas.scss';

// For Dark import Saas-Dark.scss
// import './assets/scss/Saas-Dark.scss';

// For Modern import Modern.scss
// import './assets/scss/Modern.scss';
// For modern dakr import Modern-Dark.scss
// import './assets/scss/Modern-Dark.scss';

// For Creative demo import Modern.scss
// import './assets/scss/Creative.scss';
// For Creative dark demo import Modern.scss
// import './assets/scss/Creative-Dark.scss';

import { DocumentPreviewContainer } from './components/doc-preview'
import { Worker} from '@react-pdf-viewer/core';

type AppProps = {};

/**
 * Main app component
 */
class App extends Component<AppProps> {
    render() {
        return (
            <Worker workerUrl="./pdfjs-dist/pdf.worker.min.js">
                <React.Fragment>
                    <DocumentPreviewContainer />
                    <ConfigProvider colors={['#5f0f40', '#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51']}>
                        <Routes />
                    </ConfigProvider>
                </React.Fragment>
            </Worker>
        );
    }
}


export default App;
